import facebook from "assets/images/social/Facebook.png"
import insta from "assets/images/social/Instagram.png"

const Footer = () => (
    <footer className="flex flex-col justify-center items-center p-4 bg-base-200 text-base-content">
        <div className="flex justify-center space-x-6">
            <a href="https://www.facebook.com/bitbitstdio/" target="_blank">
                <img src={facebook} className="w-20 cursor-pointer"/>
            </a>
            <a href="https://www.instagram.com/bitbit.studio/" target="_blank">
                <img src={insta} className="w-20 cursor-pointer"/>
            </a>
        </div>
        <p>
            © 2025 BitBit Studio. All rights reserved.
        </p>
    </footer>
  );
  
  export default Footer;
  